import { render, staticRenderFns } from "./removerdisciplinas.vue?vue&type=template&id=5c585106&"
import script from "./removerdisciplinas.vue?vue&type=script&lang=js&"
export * from "./removerdisciplinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports